<template>
    <v-card
        class="pb-2 pt-1 px-2"
        style="background-color:#f1ffdc; height: 550px; overflow-y: auto;"
    >
        <v-layout
            v-if="!requests.length"
            justify-center
            align-center
            class="my-3 headline"
        >
            No Requests
        </v-layout>
        <div v-if="requests.length">
            <v-card
                class="pt-4 pb-2 px-3 my-3"
                v-for="(request, index) in requests"
            >
                <v-layout row class="ml-3 mb-2">
                    <div class="font-weight-medium mr-1 width-200">
                        Date
                    </div>
                    <div>{{ request.date | time }}</div>
                </v-layout>
                <v-layout row class="ml-3 mb-2">
                    <div class="font-weight-medium mr-1 width-200">
                        Caller ID
                    </div>
                    <div>{{ formatPhoneNumber(request.from) }}</div>
                </v-layout>

                <audio
                    v-if="request.recording"
                    style="height: 25px; width: 300px;"
                    controls
                    class="ml-3 mt-2"
                    :src="request.recording"
                ></audio>
            </v-card>
        </div>
    </v-card>
</template>
<script>
import moment from "moment";
import { formatPhoneNumber } from "../../utils/helpers.js";

export default {
    props: {
        account: Object,
        requests: Array,
    },
    data() {
        return {};
    },
    async created() {},
    computed: {},
    methods: {
        formatPhoneNumber(value) {
            return formatPhoneNumber(value);
        },
    },
};
</script>
<style>
.multiple-feedback {
    overflow-y: auto;
    height: 500px !important;
}
</style>
